import { RootState } from "store";
import { createSelector } from "reselect";

export const selectAudienceViewState = (state: RootState) => state.audienceView;

export const selectLastReactionByUserId = (id: string) =>
  createSelector(selectAudienceViewState, (audienceViewState) =>
    id in audienceViewState.lastReactionByUserId
      ? audienceViewState.lastReactionByUserId[id]
      : null,
  );

export const selectIsAudienceViewExpanded = createSelector(
  selectAudienceViewState,
  (audienceViewState) => audienceViewState.isExpanded,
);

export const selectAudienceViewSlots = createSelector(
  selectAudienceViewState,
  (audienceViewState) => audienceViewState.slots,
);

export const selectIsContainerMounted = createSelector(
  selectAudienceViewState,
  (audienceViewState) => audienceViewState.isContainerMounted,
);
